///// some helpful functions \\\\\
function getUserID(name) {
  name = name.toString().replace(' ','').toLowerCase();
  while(name.length < 10) {
    name += "0";
  }
  name = name.slice(0,10);
  return parseInt(name, 36).toString(16);
}

function getUserFromID(id){
  return parseInt(id, 16).toString(36);
}

